import { Box, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { money } from '../../lib/format';
import { sumBy, useTenantScope } from '../../store/selectors';
import { SectionCard } from '../../ui/primitives';

const MONTH_START = '2026-10-01';

export default function MoneyFlowPanel() {
  const scope = useTenantScope();
  const rows = useMemo(() => {
    const month = scope.ledger.filter((entry) => entry.effectiveDate >= MONTH_START);
    const total = (types: string[]) =>
      sumBy(
        month.filter((entry) => types.includes(entry.type)),
        (entry) => entry.amount,
      );
    return [
      { label: 'Applications issued', value: total(['ISSUE']), direction: 'in' },
      { label: 'Capital call receipts', value: total(['CALL_PAYMENT']), direction: 'in' },
      { label: 'Distributions paid (net)', value: total(['DISTRIBUTION']), direction: 'out' },
      { label: 'Reinvested under DRP', value: total(['DRP_ISSUE']), direction: 'neutral' },
      { label: 'Withholding to remit to ATO', value: total(['WITHHOLDING']), direction: 'out' },
      { label: 'Redemptions', value: total(['REDEMPTION']), direction: 'out' },
    ];
  }, [scope]);
  const max = Math.max(1, ...rows.map((row) => row.value));
  return (
    <SectionCard
      title="Money movements, October 2026"
      subtitle="Posted to the ledger month to date"
    >
      <Stack spacing={1.5}>
        {rows.map((row) => (
          <Box key={row.label}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2">{row.label}</Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}
              >
                {money(row.value)}
              </Typography>
            </Stack>
            <Box
              sx={{ height: 6, bgcolor: '#F1F5F9', borderRadius: 3, mt: 0.5, overflow: 'hidden' }}
            >
              <Box
                sx={{
                  height: '100%',
                  width: `${(row.value / max) * 100}%`,
                  bgcolor:
                    row.direction === 'in'
                      ? '#0F766E'
                      : row.direction === 'out'
                        ? '#4F46E5'
                        : '#94A3B8',
                  borderRadius: 3,
                }}
              />
            </Box>
          </Box>
        ))}
      </Stack>
    </SectionCard>
  );
}
